/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import {Controller, SubmitHandler, useForm} from 'react-hook-form';
import {
    Autocomplete,
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {DipProg} from "./types";
import {useCreateDipProg} from "./Services";
import {useGetDipendenti, useGetProgetti} from "../gestversore/Services";
import {useGetDropProgettiByRef} from "../../common/Services";

interface AddDipProgProps {
  onClose: () => void;
}

// const AddDipProg  = ()  => {
const AddDipProg: React.FC<AddDipProgProps> = ({ onClose }) => {
    const validationSchema = Yup.object().shape({
              // id: Yup.number(),
              ditta: Yup.number(),
              coddip: Yup.string(),
              codprog: Yup.string(),
              molt: Yup.number().transform((_, originalValue) => originalValue ? parseFloat(originalValue.toString().replace(',', '.')): undefined)
                .typeError('Inserire un numero valido'),
        });



const {  control,  handleSubmit,  formState: { errors },  setValue,  reset,  watch,} = useForm({ resolver: yupResolver(validationSchema)});

const { mutateAsync: createDipProg, isPending: isCreatingDipProg } = useCreateDipProg();


    const { data: DropProgettiApiResponse } = useGetDropProgettiByRef();
// const {  data: ProgettiApiResponse } = useGetProgetti(2);

const {  data: DipendentiApiResponse } = useGetDipendenti(2,'');

const codprog = watch("codprog");
const coddip = watch("coddip");

const onSubmit: SubmitHandler<DipProg> = async (data) => {
          if (!coddip || !codprog) return;

          const newId = `${coddip}-${codprog}`;
          const payload = {
            ...data,
            id: newId,
          };

          try {
            await createDipProg(payload);
            onClose();
          } catch (error) {
            console.error("Error creating DipProg:", error);

          }
        };

const handleClose = () => {
            onClose();
          };

 return (

 // <Box sx={{mt: '100px' , ml:10, width: '75%'  }}>
    <Dialog onClose={onClose} open fullWidth maxWidth="sm">
    <DialogTitle>
        <Typography variant="h5">Nuova DipProg</Typography>
    </DialogTitle>
        <DialogContent>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Stack  direction="row"  justifyContent="flex-end"  spacing={1} sx={{ mt: 2, width: '15%' }} >
                      <Controller
                        name="ditta"
                        control={control}
                        defaultValue={2}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Ditta"
                            margin="dense"
                            disabled={true}
                            fullWidth
                          />
                        )}
                      />
                    </Stack>
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                        <Controller
                        name="codprog"
                        control={control}
                        render={({ field }) => (
                             <Box sx={{width: '100%'}}>
                              <Autocomplete
                                {...field}
                                disablePortal
                                options={DropProgettiApiResponse?.results ?? []}
                                getOptionLabel={(option) => option.desprog || ""}
                                onChange={(event, value) => field.onChange(value?.codprog || "")} // Update form value
                                value={DropProgettiApiResponse?.results.find((item) => item.codprog === field.value) || null}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Seleziona Progetto"
                                        margin="dense"
                                        fullWidth
                                        error={!!errors.codprog}
                                    />
                                )}
                                />
                             </Box>
                            )}
                        />
                    </Stack>
                    <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                     <Controller
                            name="coddip"
                            control={control}
                            render={({ field }) => (
                             <Box sx={{width: '100%'}}>
                              <Autocomplete
                                {...field}
                                disablePortal
                                options={DipendentiApiResponse?.results ?? []}
                                getOptionLabel={(option) => option.label || ""}
                                onChange={(event, value) => field.onChange(value?.coddip || "")} // Update form value
                                // value={DipendentiApiResponse?.results.find((item) => item.coddip === field.value) || null}
                                value={DipendentiApiResponse?.results.find((item) => item.coddip === field.value || null)}

                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Seleziona Dip"
                                        margin="dense"
                                        fullWidth
                                        // error={!!errors.id}
                                    />
                                )}
                                />
                             </Box>
                            )}
                        />
                    </Stack>

                    <Stack  direction="row"  justifyContent="flex-end"  spacing={1} sx={{ mt: 2, width: '15%' }} >
                      <Controller
                        name="molt"
                        control={control}
                        defaultValue={1}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label="Moltip.ORE"
                            margin="dense"
                            fullWidth
                          />
                        )}
                      />
                    </Stack>

                    <Stack direction="row" justifyContent="flex-end" spacing={1}
                           sx={{marginTop: '15px', width: '100%'}}>
                        <Button color="primary" type="reset" variant="outlined">CANCELLA</Button>
                        <Button variant="contained" onClick={onClose} color="error">CHIUDI</Button>
                        <Button
                            type="submit"
                            color="primary"
                            variant="contained"
                            disabled={isCreatingDipProg}
                            startIcon={isCreatingDipProg ? <CircularProgress color="inherit" size={25}/> : null}
                        >
                            SALVA
                        </Button>
                    </Stack>

            </form>


        </DialogContent>
    </Dialog>

  );
};

export default AddDipProg;